import './Footer.sass'
import logo from '../../assets/img/logo.png'
import line from '../../assets/img/footer/line.png'
import iconVk from '../../assets/img/footer/vk.png'
import iconYoutube from '../../assets/img/footer/youtube.png'
import iconTel from '../../assets/img/footer/tel.png'

export default function Footer() {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-line">
                    <img src={line} alt="" />
                </div>
                <div className="footer-block">
                    <a href="/" className="footer-logo">
                        <img src={logo} alt="footer-logo" />
                    </a>
                    <div className="footer-open">
                        <strong>Скоро открытие!</strong>
                        <p>г. Санкт-Петербург, ул. Салова, 45 лит. Ф</p>
                    </div>
                    <div className="footer-contact">
                        <a href="tel: 8 800 250 79 26">8 800 250 79 26</a>
                        <p>Звонок бесплатный</p>
                    </div>
                    <div className="footer-social">
                        <a href="https://vk.com/public149804744" target="_blank" className="footer-social__a">
                            <img src={iconVk} alt="vk" />
                        </a>
                        <a href="https://www.youtube.com/channel/UC99IYXRv42a_ccQ99_4HBEw" target="_blank" className="footer-social__a">
                            <img src={iconYoutube} alt="youtube" />
                        </a>
                        <a href="https://t.me/danogips_russia" target="_blank" className="footer-social__a">
                            <img src={iconTel} alt="telegram" />
                        </a>
                    </div>
                </div>
                <div className="footer-underline">
                    <div className="footer-underline__copy">©2022 «Danogips» - Все права защищены</div>
                    <a href="https://www.danogips.ru/politika_konfidenczialnosti.html" target="_blank" className="footer-underline__polit">Политика конфиденциальности</a>
                </div>
            </div>
        </footer>
    )
}